// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import installNavigationLifecycle from '../navigationLifecycle'

import $ from 'jquery';
global.$ = jQuery = $;

Rails.start()
Turbolinks.start()
ActiveStorage.start()

console.log("Hello from application js");

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
installNavigationLifecycle(ReactRailsUJS);

$(document).on('turbolinks:load', function() {
    console.log('turbolinks:load1');
});

document.addEventListener('turbolinks:load', () => {
    const flashMessages = document.querySelectorAll('.js-flash-message');
    flashMessages.forEach(flashMessage => {
      const closeButton = flashMessage.querySelector('.js-flash-close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          flashMessage.remove();
        });
      }
    });
});
